<template>
  <v-app>
    <ArinMenu />
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ArinMenu from "@/components/adminArin/menuadmin/ArinMenu";

export default {
  name: "DashboardArin",
  components: {
    ArinMenu,
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f8f8f8;
}

@media only screen and (max-width: 600px) {
  .v-main {
    padding: 56px 0px 0px 0px !important;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .v-main {
    padding: 56px 0px 0px 84px !important;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .v-main {
    padding: 56px 0px 0px 84px !important;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .v-main {
    padding: 56px 0px 0px 84px !important;
  }
}
</style>
